// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__V8f5a","col":"styles_col__Po4QH","actions":"styles_actions__16c9D","conflict":"styles_conflict__1pz6m"};